<template>
  <div class="form-row inline-label">
    <div class="form-column">
      <table class="term-overview">
        <thead>
          <tr>
            <th>{{ $t('paymentSelection.storeUserProductTable.table.column.product') }}</th>
            <th>{{ $t('paymentSelection.storeUserProductTable.table.column.payDirectly') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cartProductItem, key) in cartProductItems" :key="key">
            <td>{{ cartProductItem.productTitle }}</td>
            <td class="downPaymentAmount">{{ $n(getDirectAmount(cartProductItem), 'currency') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreUserProductTable',
  props: {
    cartProductItems: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  methods: {
    getDirectAmount (productItem) {
      return productItem.directPayment ? productItem.directPayment.totalPriceLine.amountWithVat.amount : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/StoreUserProductTable.vue